import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";

document.addEventListener('DOMContentLoaded', function () {

    lazyLoad();

    let myLazyLoad = new LazyLoad();

});
